export function formatTitleCase(str: string) {
  if (str === '') {
    return str;
  }
  return str.replace(/\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
